declare let mxGeometryChange: any; // available globally
declare let mxStyleChange: any; // available globally
declare let mxTerminalChange: any; // available globally
import {xmlToObj} from '../../diagram-render/helpers/xml-to-obj.util';
import * as _ from 'lodash';

export function stickerGraphChange(graph, cell, change) {
  const geometry = cell.geometry;
  const action: any = {};

  action.mxKey = Number(cell.id);
  action.position = {
    x: geometry.x,
    y: geometry.y,
    w: geometry.width,
    h: geometry.height
  };
  action.text = graph.getEditingValue(cell);
  action.position.rotation = graph.getCellStyle(cell)['rotation'] || 0;
  action.paperClass = graph.getCellStyle(cell)['paperClass'] || 'yellow-paper-gold';
  const tags = cell.tags || cell.getJson().tags;

  if (tags) {
    action.tags = tags;
  }

  if (change instanceof mxStyleChange) {
    const prev = xmlToObj(change.previous);
    const curr = xmlToObj(change.style);

    if ((prev.rotation || curr.rotation) && prev.rotation !== +curr.rotation) {
      action.position.rotation = Number(+curr.rotation);
    }

    if (+prev.locked !== +curr.locked) {
      action.locked = Boolean(+curr.locked);
    }
  }

  return {
    data: _.cloneDeep(action),
    action: 'changeNote',
    type: 'sticker',
    mxKey: Number(cell.id)
  };
}
